var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFallbackImage = function SvgFallbackImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#A9B3BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#fallback-image_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1h26s2 0 2 2v26s0 2-2 2H3s-2 0-2-2V3s0-2 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 23 4.616-6.155a2 2 0 0 1 3.015-.214L16 18l4.4-5.867a2 2 0 0 1 3.2 0l3.56 4.747M6 8.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M1 23h30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fallback-image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgFallbackImage;